import { render } from "./ValidateModal.vue?vue&type=template&id=2d49baa3"
import script from "./ValidateModal.vue?vue&type=script&lang=js"
export * from "./ValidateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__